import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@cropler/ui-kit';

import styles from '../styles/dashboard.module.scss';
import { ReactComponent as NoMatchImg } from '../assets/images/404.svg';

const NoMatch = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className={styles.noMatchContainer}>
      <div className={styles.noMatchImage}>
        <NoMatchImg />
      </div>
      <div>
        <p className={styles.noMatchTitle}>{t('noMatch.text1')}</p>
        <p className={styles.noMatchDescription}>{t('noMatch.text2') + ' 🌾'}</p>
        <Button type="primary" onClick={() => navigate('/sensors', { replace: true })} className={styles.noMatchButton}>
          {t('page404.goToHome')}
        </Button>
      </div>
    </div>
  );
};

export default NoMatch;
